import React, { useState } from "react";
import { Form as FinalForm } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import AppBar from "src/components/AppBar/AppBar";
import { Container } from "src/components/Container/Container";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import { IconName } from "src/components/Icon/Icon";
import Toast from "src/components/Toast/Toast";
import { IUser, UserRoleOptions } from "src/store/models/user.model";
import { updateUser } from "src/store/reducers/users";
import { handlePasswordUpdate } from "src/util/util.PasswordUpdate";
import * as S from "../../constants/StringConstants";

const Profile: React.FC = () => {
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const user = useSelector((state: any) => state.auth.user) as IUser;
  const dispatch = useDispatch();

  const handleProfileSubmit = async (values: any) => {
    const updatedUser = {
      ...user,
      firstName: values.firstName,
      lastName: values.lastName,
    };

    try {
      await dispatch(updateUser(updatedUser));
      setToastMessage(S.P_UPDATE_PROFILE_SUCCESS);
    } catch (error) {
      setToastMessage(S.P_UPDATE_PROFILE_ERROR);
    }
  };

  const handlePasswordSubmit = async (values: any, form: any) => {
    await handlePasswordUpdate(user.userID.toString(), values, setToastMessage, form);
  };

  // Get the label for the user's role
  const userRoleLabel = UserRoleOptions.find(option => option.value === user.userRole)?.key;

  return (
    <>
      <AppBar icon={IconName.User} title={S.P_PAGE_TITLE} />
      <section className="user-builder__wrap">
        <Container padding="3rem">
          <Row>
            <Col className="app-form-header">
              <h2 className="form-title">{S.U_USER_INFORMATION}</h2>
            </Col>
          </Row>

          <FinalForm
            onSubmit={handleProfileSubmit}
            initialValues={{
              ...user,
              userRole: userRoleLabel,
            }}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Row className="mb-3">
                  <Col sm="4">
                    <TextField label={S.U_FIRST_NAME_LABEL} name="firstName" required />
                  </Col>
                  <Col sm="4">
                    <TextField label={S.U_LAST_NAME_LABEL} name="lastName" required />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col sm="4">
                    <TextField label={S.U_EMAIL_LABEL} name="email" type="email" readOnly disabled />
                  </Col>
                  <Col sm="4">
                    <TextField label={S.U_ROLE_LABEL} name="userRole" readOnly disabled />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col className="user-builder__button-wrap">
                    <button className="button-v2 button-v2__primary" type="submit">
                      {S.U_SUBMIT_BUTTON_PROFILE}
                    </button>
                  </Col>
                </Row>
              </form>
            )}
          />
          <hr className="my-5" />
          <Row>
            <Col>
              <Col className="app-form-header">
                <h1 className="form-title">{S.U_PASSWORD_INFORMATION}</h1>
              </Col>
            </Col>
          </Row>
          <FinalForm
            onSubmit={handlePasswordSubmit}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Row className="mb-3">
                  <Col sm="4">
                    <TextField label={S.U_OLD_PASSWORD_LABEL} name="oldPassword" type="password" required />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col sm="4">
                    <TextField label={S.U_NEW_PASSWORD_LABEL} name="newPassword" type="password" required />
                  </Col>
                  <Col sm="4">
                    <TextField label={S.U_CONFIRM_PASSWORD_LABEL} name="confirmPassword" type="password" required />
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col className="user-builder__button-wrap">
                    <button className="button-v2 button-v2__primary" type="submit">
                      {S.U_SUBMIT_BUTTON_PASSWORD}
                    </button>
                  </Col>
                </Row>
              </form>
            )}
          />
        </Container>
      </section>

      <Toast message={toastMessage} onClose={() => setToastMessage(null)} open={toastMessage !== null} />
    </>
  );
};

export default Profile;
